<template>
  <!--keep-alive :key="$route.fullPath"-->
    <router-view :key="$route.path"></router-view>
  <!--/keep-alive-->
</template>

<script>
export default {
  name: 'KundeMain'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Kunde.vue